import { Link as LinkR, NavLink as NavLinkR } from 'react-router-dom';
import styled from 'styled-components';

export const Nav = styled.nav`
  position: sticky;
  top: 0;
  z-index: 999;
  width: 100%;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  background: rgba(20, 22, 35, 0.92);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.3), 
              0 1px 0 rgba(255, 255, 255, 0.05) inset;
  display: flex;
  justify-content: center;
`;

export const NavbarContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 2px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const NavLogo = styled(LinkR)`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  img {
    width: 68px;
  }
  @media (max-width: 640px) {
    img {
      width: 56px;
    }
  }
`;

export const NavItems = styled.ul`
  display: flex;
  align-items: center;
  gap: 12px;
  list-style: none;
  margin: 0;
  padding: 0;
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const NavLink = styled(NavLinkR)`
  position: relative;
  padding: 6px 12px;
  border-radius: 14px;
  color: ${({ theme }) => theme.text_secondary};
  font-weight: 500;
  text-decoration: none;
  transition: color 0.25s ease;
  z-index: 1;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 14px;
    background: rgba(133, 76, 230, 0.15);
    border: 1px solid rgba(133, 76, 230, 0.35);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s ease;
    z-index: -1;
  }
  &:hover {
    color: ${({ theme }) => theme.text_primary};
  }
  &:hover::before,
  &.active::before {
    transform: scaleX(1);
  }
  &.active {
    color: ${({ theme }) => theme.text_primary};
  }
`;

export const NavLinkExternal = styled.a`
  position: relative;
  padding: 6px 12px;
  border-radius: 14px;
  color: ${({ theme }) => theme.text_secondary};
  font-weight: 500;
  text-decoration: none;
  transition: color 0.25s ease;
  z-index: 1;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 14px;
    background: rgba(133, 76, 230, 0.15);
    border: 1px solid rgba(133, 76, 230, 0.35);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s ease;
    z-index: -1;
  }
  &:hover {
    color: ${({ theme }) => theme.text_primary};
  }
  &:hover::before {
    transform: scaleX(1);
  }
`;

export const GitHubButton = styled.a`
  padding: 8px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.02);
  
  svg {
    width: 20px;
    height: 20px;
  }
  
  &:hover {
    border-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
    background: rgba(133, 76, 230, 0.1);
    transform: translateY(-2px);
  }
  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  @media (max-width: 900px) {
    display: none;
  }
`;

export const MobileIcon = styled.button`
  display: none;
  @media screen and (max-width: 900px) {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.text_primary};
    font-size: 1.5rem;
    cursor: pointer;
  }
`;

export const MobileMenu = styled.div`
  position: absolute;
  top: 38px;
  left: 0;
  width: 100%;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  background: rgba(20, 22, 35, 0.95);
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  padding: ${({ isOpen }) => (isOpen ? '24px' : '0 24px')};
  display: flex;
  flex-direction: column;
  gap: 12px;
  transform-origin: top;
  transform: ${({ isOpen }) => (isOpen ? 'scaleY(1)' : 'scaleY(0)')};
  transition: transform 0.3s ease, padding 0.3s ease;
  pointer-events: ${({ isOpen }) => (isOpen ? 'auto' : 'none')};
  z-index: 998;
  @media (min-width: 901px) {
    display: none;
  }
`;

export const MobileLink = styled(NavLinkR)`
  padding: 14px 18px;
  border-radius: 12px;
  text-decoration: none;
  color: ${({ theme }) => theme.text_secondary};
  font-weight: 500;
  &:hover,
  &.active {
    background: rgba(133, 76, 230, 0.12);
    color: ${({ theme }) => theme.text_primary};
  }
`;

export const MobileLinkExternal = styled.a`
  padding: 14px 18px;
  border-radius: 12px;
  text-decoration: none;
  color: ${({ theme }) => theme.text_secondary};
  font-weight: 500;
  &:hover {
    background: rgba(133, 76, 230, 0.12);
    color: ${({ theme }) => theme.text_primary};
  }
`;